import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ArrowLeftIcon, SaveIcon } from 'lucide-react';
export function SupplierForm() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const supplierId = searchParams.get('id');
  const isEditing = !!supplierId;
  const [formData, setFormData] = useState({
    companyName: isEditing ? 'Premium Tea Estates Ltd' : '',
    contactPerson: isEditing ? 'Rajesh Kumar' : '',
    email: isEditing ? 'rajesh@premiumtea.lk' : '',
    phone: isEditing ? '+60 12 345 6789' : '',
    address: isEditing ? '123 Tea Estate Road, Nuwara Eliya, Sri Lanka' : '',
    productsSupplied: isEditing ? 'Ceylon Black Tea, Green Tea, White Tea' : '',
    paymentTerms: isEditing ? 'Net 30' : '',
    status: isEditing ? 'Active' : 'Active'
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle form submission
    navigate('/suppliers');
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  return <div className="space-y-6" data-id="element-9114">
      {/* Header */}
      <div className="flex items-center space-x-4" data-id="element-9115">
        <button onClick={() => navigate('/suppliers')} className="p-2 hover:bg-gray-100 rounded-md" data-id="element-9116">
          <ArrowLeftIcon size={20} data-id="element-9117" />
        </button>
        <div data-id="element-9118">
          <h2 className="text-2xl font-semibold text-gray-900" data-id="element-9119">
            {isEditing ? 'Edit Supplier' : 'Add New Supplier'}
          </h2>
          <p className="text-sm text-gray-500 mt-1" data-id="element-9120">
            {isEditing ? 'Update supplier information' : 'Enter supplier details'}
          </p>
        </div>
      </div>
      {/* Form */}
      <form onSubmit={handleSubmit} data-id="element-9121">
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-9122">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-9123">
            {/* Company Name */}
            <div className="md:col-span-2" data-id="element-9124">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-9125">
                Company Name *
              </label>
              <input type="text" name="companyName" value={formData.companyName} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter company name" data-id="element-9126" />
            </div>
            {/* Contact Person */}
            <div data-id="element-9127">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-9128">
                Contact Person *
              </label>
              <input type="text" name="contactPerson" value={formData.contactPerson} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter contact person name" data-id="element-9129" />
            </div>
            {/* Email */}
            <div data-id="element-9130">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-9131">
                Email *
              </label>
              <input type="email" name="email" value={formData.email} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="email@example.com" data-id="element-9132" />
            </div>
            {/* Phone */}
            <div data-id="element-9133">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-9134">
                Phone *
              </label>
              <input type="tel" name="phone" value={formData.phone} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="+60 12 345 6789" data-id="element-9135" />
            </div>
            {/* Payment Terms */}
            <div data-id="element-9136">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-9137">
                Payment Terms
              </label>
              <input type="text" name="paymentTerms" value={formData.paymentTerms} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="e.g., Net 30, Net 60" data-id="element-9138" />
            </div>
            {/* Address */}
            <div className="md:col-span-2" data-id="element-9139">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-9140">
                Address
              </label>
              <textarea name="address" value={formData.address} onChange={handleChange} rows={3} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter full address" data-id="element-9141" />
            </div>
            {/* Products Supplied */}
            <div className="md:col-span-2" data-id="element-9142">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-9143">
                Products/Services Supplied
              </label>
              <textarea name="productsSupplied" value={formData.productsSupplied} onChange={handleChange} rows={3} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="List products or services" data-id="element-9144" />
            </div>
            {/* Status */}
            <div data-id="element-9145">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-9146">
                Status *
              </label>
              <select name="status" value={formData.status} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-9147">
                <option value="Active" data-id="element-9148">Active</option>
                <option value="Inactive" data-id="element-9149">Inactive</option>
              </select>
            </div>
          </div>
          {/* Form Actions */}
          <div className="flex justify-end space-x-3 mt-6 pt-6 border-t border-gray-200" data-id="element-9150">
            <button type="button" onClick={() => navigate('/suppliers')} className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50" data-id="element-9151">
              Cancel
            </button>
            <button type="submit" className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700" data-id="element-9152">
              <SaveIcon size={18} className="mr-2" data-id="element-9153" />
              {isEditing ? 'Update Supplier' : 'Create Supplier'}
            </button>
          </div>
        </div>
      </form>
    </div>;
}